/**
 */

define('directives/common/training/training.directives',['app'], function (app) {
    app.directive('trainingExperience', ['UserInfo','auiDialog','$filter',function (UserInfo,auiDialog,$filter) {
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope: {
                formName:"=",
                experienceDetails:"=",
				isAudting:"="
            },
            templateUrl: 'directives/common/training/training.template.html',
            link: function ($scope, element, attrs) {
            	$scope.keys = {timeS:'startTime',timeE:'endTime',name:'name',dtl:'detail'};
                $scope.trainExperienceNum = sysParamCfg.trainExperienceNum;
            	$scope.experienceDetails = ($scope.experienceDetails && $scope.experienceDetails.length > 0) ? $scope.experienceDetails:[{startTime0:'',endTime0:'',name0:'',detail0:'',index:0}];
            	function init(){
                	addIndexAttr();
                }
                init();
                $scope.today = new Date();
                $scope.$watch('experienceDetails', function () {
                    addIndexAttr();
                });
                function addIndexAttr(){
                	if($scope.experienceDetails && $scope.experienceDetails.length>0){
                		for(var i=0;i<$scope.experienceDetails.length;i++){
                            var experienceDetailsIndex={};
                            var oldIndex=$scope.experienceDetails[i].index;
                            if($scope.experienceDetails[i]['startTime'+oldIndex] == '' || $scope.experienceDetails[i]['startTime'+oldIndex] == '--')break;
                            $scope.experienceDetails[i]['startTime'+oldIndex] = $filter('date')($scope.experienceDetails[i]['startTime'+oldIndex], 'y-MM-dd');
                            $scope.experienceDetails[i]['endTime'+oldIndex] = $filter('date')($scope.experienceDetails[i]['endTime'+oldIndex], 'y-MM-dd');
                            //需要重新排序
                            experienceDetailsIndex.index = i;
                            experienceDetailsIndex[$scope.keys.timeS+i] = ($scope.experienceDetails[i]['startTime'+oldIndex].length>10 ? $scope.experienceDetails[i]['startTime'+oldIndex]:$filter('auiDateFormat')($scope.experienceDetails[i]['startTime'+oldIndex], '+0000'));
                            experienceDetailsIndex[$scope.keys.timeE+i] = ($scope.experienceDetails[i]['endTime'+oldIndex].length>10 ? $scope.experienceDetails[i]['endTime'+oldIndex]:$filter('auiDateFormat')($scope.experienceDetails[i]['endTime'+oldIndex], '+0000'));
                            experienceDetailsIndex['name'+i] = $scope.experienceDetails[i]['name'+oldIndex];
                            experienceDetailsIndex['detail'+i] = $scope.experienceDetails[i]['detail'+oldIndex];
                            $scope.experienceDetails[i] = angular.copy(experienceDetailsIndex);
                		}
                	}
                }
                
                $scope.delRow = function(row){
                	if($scope.experienceDetails.length == 1){
                		auiDialog.warn('培训经历不能为空。');
                		return;
                	}
                	for(var h = 0; h < $scope.experienceDetails.length; h++) {
                	    if($scope.experienceDetails[h].index == row.index) {
                	    	$scope.experienceDetails.splice(h, 1);
                            addIndexAttr();
                            $scope.formName.$setDirty(true);
	                	     break;
                	    }
                	}
                };
                
                $scope.addRow = function(row){
                	if($scope.experienceDetails.length >= $scope.trainExperienceNum){
                		auiDialog.warn('最多可以填写'+$scope.trainExperienceNum+'条培训经历。');
                		return;
                	}
                	if($scope.experienceDetails.length == 0){
                		$scope.experienceDetails.push({index:0});
                	}else{
                		$scope.experienceDetails.push({index:$scope.experienceDetails[$scope.experienceDetails.length-1].index + 1});
                	}
                };
                
            }
        }
    }]);
});

